import useTranslation from '@/hooks/useTranslation';
import { ErrorPage } from './ErrorPage';

export const NotFoundErrorPage = ({ ...rest }) => {
    const { t } = useTranslation('common');
    return (
        <ErrorPage
            title="404"
            subtitle={t('Feedback.NotFoundErrorPage.subtitle')}
            message={t('Feedback.NotFoundErrorPage.message')}
            {...rest}
        />
    );
};
